import { useState, useEffect } from "react";

// Persisted (localStorage) collapsed state for the desktop sidebar, synced across
// the Sidebar + Layout via a window event. Default = expanded; stays collapsed
// across reloads / re-opening the app until toggled back.
const KEY = "sc_sidebar_collapsed";
const read = () => {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
};

export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(read);
  useEffect(() => {
    const onChange = () => setCollapsed(read());
    window.addEventListener("sidebar-collapsed-changed", onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("sidebar-collapsed-changed", onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);
  const set = (v) => {
    try { localStorage.setItem(KEY, v ? "1" : "0"); } catch { /* ignore */ }
    setCollapsed(v);
    window.dispatchEvent(new Event("sidebar-collapsed-changed"));
  };
  return [collapsed, set];
}
